module.exports = "/_next/static/resources/girls-inc-wide-40f5505c9db0bcfde8e7c9106526adf9.webp";